<template>
    <IntegrationSettingsCard :integration="integration">
        <template v-slot:body>
            <p class="mb-12">{{ __('integrations.config_required') }}</p>
            <div class="form-group">
                <label for="zoho_zone">{{ __('integrations.zoho.zone') }}</label>
                <select class="form-control" id="zoho_zone" v-model="configs.zoho_zone">
                    <option :selected="configs.zoho_zone === null" disabled>
                        {{ __('actions.please_select') }}
                    </option>
                    <option v-for="zone in zones" :value="zone.countryCode">
                        {{ zone.name }}
                    </option>
                </select>
            </div>

            <div class="d-flex flex-row justify-content-end pt-2">
                <div>
                    <button class="btn btn-sm btn-outline-warning" :disabled="!enableSaveButton" @click="saveUserSettingsAndAuthorize">
                        <i class="fas fa-user-lock"/>
                        {{ __('actions.save_and_authorize') }}
                    </button>
                </div>
            </div>
        </template>
    </IntegrationSettingsCard>
</template>

<script>
import IntegrationSettingsCard from '@components/Integrations/IntegrationSettingsCard.vue';
import IntegrationAuthSettingsLayout from '@layouts/IntegrationAuthSettingsLayout.vue';

export default {
    components: {IntegrationSettingsCard},

    layout: IntegrationAuthSettingsLayout,

    props: {
        integration: Object,
        formData: Object,
    },

    data() {
        return {
            configs: {
                zoho_zone: null,
            },
            zones: {
                'US': {
                    name: 'United States',
                    countryCode: 'us',
                },
                'EU': {
                    name: 'Europe',
                    countryCode: 'eu',
                },
            },
        };
    },

    computed: {
        enableSaveButton() {
            return this.configs.zoho_zone !== null;
        }
    },

    methods: {
        saveUserSettingsAndAuthorize() {
            this.$inertia.post(this.$route('integration.update.auth-settings', [this.integration.code]), {
                zoho_zone: this.configs.zoho_zone,
            });
        },
    }
};
</script>
